import { c as _c } from "react/compiler-runtime";
import { useLoggedInUser } from '@/client/hooks/use-logged-in-user';
interface CurrentUserHook {
  currentUserScopes: string[];
}
export function useCurrentUserScopes() {
  const $ = _c(2);
  const user = useLoggedInUser();
  if (!user) {
    throw new Error("Not logged in");
  }
  const currentUserScopes = user.scopes;
  let t0;
  if ($[0] !== currentUserScopes) {
    t0 = {
      currentUserScopes
    };
    $[0] = currentUserScopes;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}